// Components.
import ModalAssinaturaEletronica from '@/components/assinatura-eletronica/Modal'

// Others.
import { mapActions } from 'vuex'
import { repository, error } from '@/mixins'

export default {
    components: { ModalAssinaturaEletronica },
    data: () => ({
        modalAssinaturaEletronicaRefName: 'ModalAssinaturaEletronica',
        modalAssinaturaEletronicaFaaProps: {
            skipSignConfirmationMessage: 'Deseja realmente assinar depois?',
            skipSignText: 'Assinar depois',
        },
        modalAssinaturaEletronicaReceitaMedicaProps: {
            skipSignConfirmationMessage: 'Deseja realmente assinar depois?',
            skipSignText: 'Assinar depois',
        },
        afterSign: async () => {},
        onSign: () => {},
        onSkipSign: () => {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        askToSignAtendimento(signCallback, notSignCallback) {

            this.askToSign('Atendimento salvo. Deseja assinar?', signCallback, notSignCallback)
        },
        askToSignReceita(signCallback, notSignCallback) {

            this.askToSign('Deseja assinar a receita médica?', signCallback, notSignCallback)
        },
        askToSign(message, signCallback, notSignCallback) {

            this.showConfirmation(message, signCallback, notSignCallback)
        },
        signFaa(atendimentoId, atendimentos = [], fileName = 'faa') {

            const repository = this.getConectaSusRepository('impressao.prontoAtendimento')

            this.setLoading()

            repository.faa.eletronica(atendimentoId, { atendimentos, para_assinatura_eletronica: true })
                .then(response => this.$refs[this.modalAssinaturaEletronicaRefName].open(
                    new Blob([response.data], { type: response.headers['content-type'] }),
                    fileName
                ))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        signReceitaMedica(files, fileName = 'receita-medica') {

            this.$refs[this.modalAssinaturaEletronicaRefName].open(files, fileName)
        }
    },
    mixins: [repository, error]
}